import { Component, OnInit } from '@angular/core';
import { LotService } from "../../core/services/lot.service";
import { CommonService } from "../../core/services/common.service";
import { Pagination } from '../../core/models/pagination.model';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';


@Component({
    selector: 'app-lot-list',
    templateUrl: './lot-list.component.html',
    styleUrls: ['./lot-list.component.css']
})
export class LotListComponent implements OnInit {

    lots: any[];
    company_name: string;
    blue_collar_staff: Pagination = new Pagination;
    white_collar_staff: Pagination = new Pagination;
    white: string = 'white';
    blue: string = 'blue';
    filterParams: URLSearchParams = new URLSearchParams();
    filterFormGroup: FormGroup;


    constructor(
        private lotService: LotService,
        private commonService: CommonService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router
    ) { }

    ngOnInit(): void {

        this.initForm();

        this.route.params.subscribe(params => {

            Object.keys(params).forEach(key => {
                if (params[key] !== '') {
                    this.filterParams.set(key, params[key]);
                }
            });

            // this.filterResults();
        });
        this.subscribeToQueryChanges();
    }


    initForm(): void {
        this.filterFormGroup = this.fb.group({
            lot_name: "all"
        });
    }

    subscribeToQueryChanges() {

        this.route.queryParams.subscribe(params => {
            Object.keys(params).forEach(key => {
                if (params[key] !== '') {
                    this.filterParams.set(key, params[key]);
                }
            });
            this.filterResults();
        });
    }

    filterResults() {

        this.lotService.getAll(this.filterParams).subscribe(
            response => {
                // this.lots = response['lots'];
                this.company_name = response['company_name'];
                this.blue_collar_staff = response['blue_collar_staff'];
                this.white_collar_staff = response['white_collar_staff'];
            },
            error => {
                this.commonService.notifications.error('Some Error Occurred');
            }
        );
    }

    filterQueriedResults(): void {
        this.filterParams = new URLSearchParams();

        // Set our navigation extras object
        // that contains our global query params and fragment
        const navigationExtras: NavigationExtras = {
            queryParams: this.filterFormGroup.value,
            queryParamsHandling: "merge"
        };

        // Get the current path
        const currentUrlPath = this.router.url.split("?")[0];

        this.router.navigate([currentUrlPath], navigationExtras);
    }

    // Reset the form to its initial state with default value
    // And then filter results
    resetForm(): void {
        this.initForm();
        this.filterQueriedResults();
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/lot/lot-list/lot-list.component.ts